import React, { FC, useMemo, memo, useCallback, useContext } from "react";
import SelectFilter from "../components/SelectFilter";
import { CaseTypes } from "src/share/types/case/case";
import { FiltersContext } from "../context/FiltersProvider";
import { SelectFilterOption, FilterType } from "../types";

const CaseTypeFilter: FC = () => {
  const { actions } = useContext(FiltersContext);
  const options: SelectFilterOption[] = useMemo(
    () =>
      Object.keys(CaseTypes).map((key) => ({
        value: CaseTypes[key] as string,
        label: CaseTypes[key] as string,
      })),
    [CaseTypes]
  );
  const handleSelected = useCallback(
    (caseType: string) => actions.onSelect(FilterType.CASE_TYPE, caseType),
    [actions.onSelect]
  );
  return (
    <SelectFilter
      label="Case Type"
      options={options}
      onSelect={handleSelected}
    />
  );
};

export default memo(CaseTypeFilter);
